<div class="electrical-services-container" [formGroup]="electricalServicesForm">
    <div class="row col-sm-12">
        <label class="mb-2">{{ 'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_TITLE' | translate }}</label>
    </div>
    <fieldset>
        <legend>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_POWER_STUDY' | translate}}</legend>
        <div class="row" >
            <div class="col-sm-4">
                <div class="row row-height col-sm-12">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_RISK_PERCENTAGE' | translate}}</label></div>
                    <div class="col-sm-4">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput type="text" mask="percent" suffix="%" formControlName="riskPercentage">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-height col-sm-12">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_COST_PER_LABEL' | translate}}</label></div>
                    <div class="col-sm-4">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput type="text" mask="separator.2" suffix="" prefix="$" formControlName="costPerLabel">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="row row-height">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_FIELD_DATA_COLLECTION_RATE' | translate}}</label></div>
                    <div class="col-sm-4">
                        {{electricalServicesForm.get('fieldDataCollectionRate')?.value | currency}}
                    </div>
                </div>
                <div class="row row-height">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_DATA_COLLECTION_MULT' | translate}}</label></div>
                    <div class="col-sm-4">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput type="text" mask="decimal.2" suffix="%" formControlName="dataCollectionMultiplier">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-height">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_BASE_STUDY_DIFFICULTY_MULT' | translate}}</label></div>
                    <div class="col-sm-4">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput type="text" mask="decimal.2" suffix="%" formControlName="baseStudyDifficultyMultiplier">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row row-height">
                    <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_MOTOR_STARTING_STUDY_MULT' | translate}}</label></div>
                    <div class="col-sm-4">
                        <mat-form-field class="full-width col-sm-12" appearance="outline">
                            <input matInput type="text" mask="decimal.2" suffix="%" formControlName="motorStartingStudyMultiplier">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_SHORT_CIRCUIT_STUDY' | translate}}</legend>
        <div class="row row-height col-sm-4 ps-0">
            <div class="col-sm-5"><label>{{'MENU_FILE_PROPERTIES_ELECTRICAL_SERVICES_RISK_PERCENTAGE' | translate}}</label></div>
            <div class="col-sm-4 ps-1 pe-3">
                <mat-form-field class="full-width col-sm-12" appearance="outline">
                    <input matInput type="text" mask="percent" suffix="%" formControlName="shortCircuitRiskPercentage">
                </mat-form-field>
            </div>
        </div>
    </fieldset>
</div>